import { CommonModule } from '@angular/common';
import { Component, computed, effect, input, output, signal } from '@angular/core';

@Component({
  selector: 'app-search-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss',
})
export class SearchBarComponent<T = any> {
  // Dot-notation supported, e.g. 'course.name'.
  data = input<T[]>([]);
  searchKeys = input<string[]>([]);
  placeholder = input<string>('Search');
  shortcutLabel = input<string>('');

  filtered = output<T[]>();
  queryChange = output<string>();

  query = signal('');

  readonly filteredResults = computed(() => this.filterData(this.data(), this.query()));

  constructor() {
    effect(() => {
      this.filtered.emit(this.filteredResults());
    });
  }

  onInput(value: string): void {
    this.query.set(value);
    this.queryChange.emit(value);
  }

  clear(): void {
    this.query.set('');
    this.queryChange.emit('');
  }

  private filterData(items: T[], query: string): T[] {
    const trimmed = query.trim().toLowerCase();
    if (!trimmed) {
      return items;
    }
    const keys = this.searchKeys();
    return items.filter((item) =>
      keys.some((key) =>
        String(this.resolveValue(item, key) ?? '')
          .toLowerCase()
          .includes(trimmed),
      ),
    );
  }

  private resolveValue(item: T, path: string): unknown {
    return path.split('.').reduce<any>((acc, part) => (acc == null ? acc : acc[part]), item);
  }
}
